/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {TDefinePropertiesStep} from "../../../../../../../redux/ducks/AdasPrograms/slice"

export interface PropertyField {
  id: string
  label: string
  unit: string
  required: boolean
}

export const PROPERTY_FIELDS: PropertyField[] = [
  {
    id: 'sensor-desired-fov-degrees',
    label: 'Sensor Desired FOV',
    unit: 'deg',
    required: true,
  },
  {
    id: 'x-nominal',
    label: 'X Nominal',
    unit: 'm',
    required: true,
  },
  {
    id: 'x-minimum',
    label: 'X Minimum',
    unit: 'm',
    required: true,
  },
  {
    id: 'x-maximum',
    label: 'X Maximum',
    unit: 'm',
    required: true,
  },
  {
    id: 'y-nominal',
    label: 'Y Nominal',
    unit: 'm',
    required: true,
  },
  {
    id: 'y-minimum',
    label: 'Y Minimum',
    unit: 'm',
    required: true,
  },
  {
    id: 'y-maximum',
    label: 'Y Maximum',
    unit: 'm',
    required: true,
  },
  {
    id: 'z-nominal',
    label: 'Z Nominal',
    unit: 'm',
    required: true,
  },
  {
    id: 'z-minimum',
    label: 'Z Minimum',
    unit: 'm',
    required: true,
  },
  {
    id: 'z-maximum',
    label: 'Z Maximum',
    unit: 'm',
    required: true,
  },
  {
    id: 'yaw-nominal',
    label: 'Yaw Nominal',
    unit: 'deg',
    required: true,
  },
  {
    id: 'yaw-minimum',
    label: 'Yaw Minimum',
    unit: 'deg',
    required: true,
  },
  {
    id: 'yaw-maximum',
    label: 'Yaw Maximum',
    unit: 'deg',
    required: true,
  },
  {
    id: 'pitch-nominal',
    label: 'Pitch Nominal',
    unit: 'deg',
    required: true,
  },
  {
    id: 'pitch-minimum',
    label: 'Pitch Minimum',
    unit: 'deg',
    required: true,
  },
  {
    id: 'pitch-maximum',
    label: 'Pitch Maximum',
    unit: 'deg',
    required: true,
  },
  {
    id: 'roll-nominal',
    label: 'Roll Nominal',
    unit: 'deg',
    required: true,
  },
  {
    id: 'roll-minimum',
    label: 'Roll Minimum',
    unit: 'deg',
    required: true,
  },
  {
    id: 'roll-maximum',
    label: 'Roll Maximum',
    unit: 'deg',
    required: true,
  },
  {
    id: 'material-thickness-nominal',
    label: 'Material Thickness Nominal',
    unit: 'mm',
    required: true,
  },
  {
    id: 'material-thickness-minimum',
    label: 'Material Thickness Minimum',
    unit: 'mm',
    required: true,
  },
  {
    id: 'material-thickness-maximum',
    label: 'Material Thickness Maximum',
    unit: 'mm',
    required: true,
  },
  {
    id: 'material-performance-degradation',
    label: 'Material Performance Degradation',
    unit: 'dB',
    required: true,
  },
  {
    id: 'mount-build-tolerance-to-ground-elevation',
    label: 'Mount Build Tolerance to Ground Elevation',
    unit: 'deg',
    required: true,
  },
  {
    id: 'mount-build-tolerance-to-ground-azimuth',
    label: 'Mount Build Tolerance to Ground Azimuth',
    unit: 'deg',
    required: true,
  },
  {
    id: 'mount-build-tolerance-to-ground-roll',
    label: 'Mount Build Tolerance to Ground Roll',
    unit: 'deg',
    required: true,
  },
]

export const PROPERTY_KEY: { [key: string]: keyof TDefinePropertiesStep } = {
  'sensor-desired-fov-degrees': 'sensorDesiredFovDegrees',
  'x-nominal': 'xNominal',
  'x-minimum': 'xMinimum',
  'x-maximum': 'xMaximum',
  'y-nominal': 'yNominal',
  'y-minimum': 'yMinimum',
  'y-maximum': 'yMaximum',
  'z-nominal': 'zNominal',
  'z-minimum': 'zMinimum',
  'z-maximum': 'zMaximum',
  'yaw-nominal': 'yawNominal',
  'yaw-minimum': 'yawMinimum',
  'yaw-maximum': 'yawMaximum',
  'pitch-nominal': 'pitchNominal',
  'pitch-minimum': 'pitchMinimum',
  'pitch-maximum': 'pitchMaximum',
  'roll-nominal': 'rollNominal',
  'roll-minimum': 'rollMinimum',
  'roll-maximum': 'rollMaximum',
  'material-thickness-nominal': 'materialThicknessNominal',
  'material-thickness-minimum': 'materialThicknessMinimum',
  'material-thickness-maximum': 'materialThicknessMaximum',
  'material-performance-degradation': 'materialPerformanceDegradation',
  'mount-build-tolerance-to-ground-elevation': 'mountBuildToleranceToGroundElevation',
  'mount-build-tolerance-to-ground-azimuth': 'mountBuildToleranceToGroundAzimuth',
  'mount-build-tolerance-to-ground-roll': 'mountBuildToleranceToGroundRoll',
}
